import React from "react";
import { connect } from 'react-redux';
import axios from 'axios'
import 'react-telephone-input/lib/withStyles';

import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';

import {getCurrentUser, getCurrentUserSuccess, getUpdateUserDataError} from '../../actions/session';
import {setErrorMessage, resetErrors} from '../../actions';
import PersonalDataForm from './PersonalDataForm';
import defaultAvatar from '../../images/default-avatar.jpg';
import { getHeader } from "../../helper";

class PersonalData extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            formEdit: false,

            last_name: '',
            first_name: '',
            username: '',
            patronymic_name: '',
            phone: '',
            phone_additional: '',
            avatar: null,
            file: null,
            password: '',
            passwordDefault: '********',

            selectedCountry: '',
            phoneAdditionalCountry: '',

            fieldErrors: {
                isValid: true,
            },

            phoneDisabled: true,
            checkChanged: false,

            // email_code_sended: false,
            // phone_code_sended: false,
            // phone_additional_code_sended: false,

            phone_sms_time: 0,
            phone_additional_sms_time: 0,
        }
    }

    componentDidMount() {
        this.setCurrentData();

        this.props.getCurrentUser(
            this.props.session.token,
            () => console.log('ok!'),
            true
        );
    }

    getConfirmationCode(type) {
        if(!type) return false;
        // console.warn('getConfirmationCode', type);

        axios.get(`${window.siteUrl}/api/v1/get_confirmation_key/`, {
            params: {type},
            headers: getHeader()
        })
        .then(response => {
            // console.warn('getConfirmationCodeReceive', response.data);
            if(type === 'email') this.getEmailCodeSuccess(type);
            else this.getPhoneCodeSuccess(type);
        })
        .catch(error => {
            let errors = Object.assign({}, error.response);
            // console.warn('getConfirmationCodeError', errors.data);
            this.getConfirmationCodeError(errors.data || {});
        });
    }

    getEmailCodeSuccess(type) {
        Alert.info('Код подтверждения отправлена на эл. почту', {
            position: 'bottom-left',
            effect: 'stackslide',
            timeout: 5000
        });

        this.setState({email_code_sended: true});
    }

    getPhoneCodeSuccess(type) {
        Alert.info('Код подтверждения отправлена на номер телефона', {
            position: 'bottom-left',
            effect: 'stackslide',
            timeout: 5000
        });

        let count = this.state[`${type}_code_sended`] || 0;

        this.setState({
            [`${type}_code_sended`]: (count+1),
            [`${type}_sms_time`]: 300,
        }, () => {
            this[`intervalTick${type}`] = setInterval(() => this.tick(type), 1000);
        });
    }

    getConfirmationCodeError(error) {
        let errorArray = [];
        Object.keys(error).map(key => {
            if(Array.isArray(error[key])) {
                errorArray.push(error[key].join("\n"))
            }
            else {
                errorArray.push(error[key]);
            }
        });

        if(!errorArray.length) {
            errorArray.push('Код подтверждения не отправлен');
        }

        Alert.error(errorArray.join("\n"), {
            position: 'bottom-left',
            effect: 'stackslide',
            timeout: 5000
        });
    }

    confirmationCode(e, type) {
        e.preventDefault();
        let key = this.state[`${type}_key`];
        // console.warn('confirmationCode request', type, key);
        
        axios.get(`${window.siteUrl}/api/v1/confirm_phone/`, {
            params: {
                type,
                key
            },
            headers: getHeader()
        })
        .then(response => {
            // console.warn('confirmationCodeReceive', response.data);
            this.confirmationSuccess(type);
        })
        .catch(error => {
            let errors = Object.assign({}, error.response);
            // console.warn('confirmationCodeError', errors.data);
            this.getConfirmationCodeError(errors.data || {});
        });
    }

    confirmationSuccess(type) {
        Alert.success('Номер телефона подтвержден', {
            position: 'bottom-left',
            effect: 'stackslide',
            timeout: 5000
        });

        let param = {};
        if(type === "phone") param = {is_phone_confirmed: true};
        else if(type === "phone_additional") param = {is_phone_additional_confirmed: true};

        this.props.getCurrentUserSuccess(param);

        this.setState({
            [`${type}_code_sended`]: 0,
            [`${type}_sms_time`]: 0,
            [`${type}_key`]: '',
        }, () => {
            clearInterval(this[`intervalTick${type}`]);
        });
    }

    tick(type) {
        if(this.state[`${type}_sms_time`] < 1) {
            this.setState({
                [`${type}_sms_time`]: 0,
            }, () => clearInterval(this[`intervalTick${type}`]));
            return;
        }

        this.setState({
            [`${type}_sms_time`]: this.state[`${type}_sms_time`] - 1
        });
    }

    setCurrentData() {
        const {currentUser} = this.props.session;

        this.setState({
            last_name: currentUser.last_name,
            first_name: currentUser.first_name,
            patronymic_name: currentUser.patronymic_name,
            phone: currentUser.phone,
            phone_additional: currentUser.phone_additional,
            avatar: currentUser.avatar,
            username: currentUser.username,
            file: null,
            password: '',
        });
    }

    onEdit(save = false) {
        if(this.state.formEdit && save === false)
            this.setCurrentData();

        this.setState({
            formEdit: !this.state.formEdit,
            phoneDisabled: !this.state.formEdit ? false : true,
            fieldErrors: {
                isValid: true,
            }
        });
    }

    handleOnChange(value, field) {
        this.setState({
            [field]: value,
            checkChanged: true
        })
    }

    onSubmit(e){
        e.preventDefault();

        if(!this.state.checkChanged) {
            Alert.error('Изменений нет', {
                position: 'bottom-left',
                effect: 'stackslide',
                timeout: 5000
            });
            return;
        }

        const { currentUser, token } = this.props.session;
        const formData = new FormData();

        formData.append('last_name', this.state.last_name);
        formData.append('first_name', this.state.first_name);
        formData.append('patronymic_name', this.state.patronymic_name);
        formData.append('phone', this.state.phone);
        formData.append('phone_additional', this.state.phone_additional);
        formData.append('email', this.state.username);

        if(this.state.password.trim().length > 0) {
            formData.append('password', this.state.password);
        }

        if(this.state.file)
            formData.append('avatar', this.state.file);

        if(!this.state.fieldErrors.isValid){
            return false;
        }

        axios.patch(
            `${window.siteUrl}/api/v1/user/${currentUser.id}/`,
            formData,
            {
                headers: getHeader()
            }
        )
        .then(response => {
            this.setState({
                checkChanged: false
            }, () => {
                Alert.success('Изменения сохранены', {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
            })

            this.props.getCurrentUserSuccess(response.data)
            this.onEdit(true)
            this.props.resetErrors()
        })
        .catch(error=> {
            this.props.setErrorMessage(error.response.data)
            this.props.getUpdateUserDataError(error.response.data)
        });
    }

    handleImageChange(e) {
        e.preventDefault();

        const reader = new FileReader();
        const file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                file,
                avatar: reader.result,
                checkChanged: true
            });
        }

        reader.readAsDataURL(file)
    }

    handlePhoneChange(phone, country, field) {
        const initCountry = Object.assign({}, this.state.selectedCountry);

        let code = "+" + country.dialCode;
        let myCode = phone.substr(0, code.length);

        let isValid = (initCountry.format && (myCode !== code)) ? false : true;

        this.setState({
            [field]: phone,
            selectedCountry: country,
            fieldErrors: {
                ...this.state.fieldErrors,
                isValid: isValid ? true : false,
                [field]: isValid ? false : true
            },
            checkChanged: initCountry.format ? true : false,
        });
    }

    handlePhoneBlur(phone, country, field) {
        let code = "+" + country.dialCode;
        let myCode = phone.substr(0, code.length);

        let isValid = (myCode !== code) ? false : true;

        this.setState({
            [field]: phone,
            selectedCountry: country,
            fieldErrors: {
                ...this.state.fieldErrors,
                isValid: isValid ? true : false,
                [field]: isValid ? false : true
            }
        });
    }

    render() {
        const { currentUser } = this.props.session;
        const {errorMessages} = this.props;

        let inputProps = {
            phone_key: this.state.phone_key,
            phone_additional_key: this.state.phone_additional_key,
            email_code_sended: this.state.email_code_sended,
            phone_code_sended: this.state.phone_code_sended,
            phone_additional_code_sended: this.state.phone_additional_code_sended,
            phone_sms_time: this.state.phone_sms_time,
            phone_additional_sms_time: this.state.phone_additional_sms_time,
        }

        return  (
            <div className="right-content native-scroll right-content-bottom right-content-width">
                <div className="screen-outer-block-wrap native-scroll menu-content">
                    <div className="menu-content-personal-data menu-content-item tab-parent screen-center-block">

                        <Alert stack={{limit: 1}} />

                        <div className="rounded-white-block">
                            <PersonalDataForm
                                {...this.state}
                                currentUser={currentUser}
                                errorMessages={errorMessages}
                                onEdit={() => this.onEdit()}
                                onSubmit={(e) => this.onSubmit(e)}
                                handleImageChange={this.handleImageChange.bind(this)}
                                handleOnChange={(value, field) => this.handleOnChange(value, field)}
                                handlePhoneBlur={(val, val2, field) => this.handlePhoneBlur(val, val2, field)}
                                handlePhoneChange={(val, val2, field) => this.handlePhoneChange(val, val2, field)}

                                confirmations={inputProps}
                                confirmationCode={this.confirmationCode.bind(this)}
                                getConfirmationCode={this.getConfirmationCode.bind(this)}
                                handleConfirmationCode={(type, value) => this.setState({[type]: value})}
                                />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
	state => ({
        ...state
	}),
    {
        getUpdateUserDataError,
        getCurrentUserSuccess,
        setErrorMessage,
        getCurrentUser,
        resetErrors,
    }
)(PersonalData);


// WEBPACK FOOTER //
// ./src/components/Account/PersonalData.js